/**
 * Production domain redirect (P0 — aiimagesuites.pro cutover).
 *
 * Bounces visitors from the legacy emergent preview / production host to
 * the canonical aiimagesuites.pro domain. Gated behind
 * REACT_APP_REDIRECT_TO_PROD so this code is INERT until DNS for
 * aiimagesuites.pro is verified live — flipping the env flag to "true"
 * activates the redirect without a code deploy.
 *
 * Safety:
 *   * Never redirects from localhost (dev would break)
 *   * Never redirects FROM aiimagesuites.pro TO aiimagesuites.pro (loop guard)
 *   * Preserves the path + query string so deep links work
 *   * Uses location.replace so the back button doesn't trap the user
 */
export function maybeRedirectToProduction() {
  if (typeof window === "undefined") return; // SSR / unit-test no-op
  const enabled = (process.env.REACT_APP_REDIRECT_TO_PROD || "")
    .toString()
    .toLowerCase() === "true";
  if (!enabled) return;
  const host = window.location.hostname || "";
  // Match the actual preview / deployed host patterns.
  const isLegacyHost = host.endsWith(".preview.emergentagent.com")
    || host.endsWith(".emergentagent.com")
    || host.endsWith(".emergent.host")
    || host.endsWith(".emergent.sh");
  if (!isLegacyHost) return;
  // Loopback guard
  if (host === "aiimagesuites.pro" || host === "www.aiimagesuites.pro") return;
  const target = "https://aiimagesuites.pro"
    + window.location.pathname
    + window.location.search;
  // eslint-disable-next-line no-console
  console.info("[aiimagesuites] redirecting to prod:", target);
  window.location.replace(target);
}
